import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, Typography, styled } from "@mui/material";
import Header from "../componentsPeopletech/Header";
import BarraApp from "../componentsPeopletech/Barraaps";
import ServicesCircles from "../componentsPeopletech/ServicesCircles";
import Footer from "../componentsPeopletech/Footer/Footer";
import ContactSection from "../componentsPeopletech/ContactSection";
import AcademyBooking from "../componentsPeopletech/AcademyBooking";

const BackgroundVideoContainer = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: -1,
  overflow: "hidden",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 1,
  },
});

const Video = styled("video")({
  position: "absolute",
  top: "50%",
  left: "50%",
  minWidth: "100%",
  minHeight: "100%",
  width: "auto",
  height: "auto",
  transform: "translate(-50%, -50%)",
  filter: "blur(5px)",
  objectFit: "cover",
  zIndex: 0,
  opacity: 1,
});

const ContentWrapper = styled(Box)({
  position: "relative",
  zIndex: 1,
  backgroundColor: "transparent",
});

const academyItems = [
  { key: "chatgpt", titleKey: "academy.class1Title", descriptionKey: "academy.class1Desc" },
  { key: "n8n", titleKey: "academy.class2Title", descriptionKey: "academy.class2Desc" },
  { key: "cursor", titleKey: "academy.class3Title", descriptionKey: "academy.class3Desc" },
  { key: "agents", titleKey: "academy.class4Title", descriptionKey: "academy.class4Desc" },
  { key: "marketing", titleKey: "academy.class5Title", descriptionKey: "academy.class5Desc" },
  { key: "pyme", titleKey: "academy.class6Title", descriptionKey: "academy.class6Desc" },
];

const AcademyPeople = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "es";
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/academy`;
  const [topic, setTopic] = useState("");

  return (
    <>
      <Helmet>
        <title>{t("academy.seoTitle")}</title>
        <meta name="description" content={t("academy.seoDescription")} />
        <link rel="canonical" href={pageUrl} />
        <html lang={currentLang} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={t("academy.seoTitle")} />
        <meta property="og:description" content={t("academy.seoDescription")} />
      </Helmet>
      <BackgroundVideoContainer>
        <Video autoPlay loop muted playsInline src="/18192389-hd_1920_1080_60fps.mp4">
          Tu navegador no soporta la reproducción de videos.
        </Video>
      </BackgroundVideoContainer>
      <ContentWrapper>
        <BarraApp />
        <Header
          title={t("academy.title")}
          subtitle={t("academy.subtitle")}
          cta={t("academy.ctaBook")}
          ctaHref="#reservar"
        />
        <ServicesCircles
          items={academyItems}
          onItemClick={(item) => {
            setTopic(t(item.titleKey));
            document.getElementById("reservar")?.scrollIntoView({ behavior: "smooth" });
          }}
        />
        <Box sx={{ textAlign: "center", px: 2, mb: 1 }}>
          <Typography variant="body1" sx={{ color: "#111" }}>
            {t("academy.priceBanner")}
          </Typography>
          <Typography variant="body2" sx={{ color: "#111", mt: 2, fontWeight: 700 }}>
            {t("academy.guidesTitle")}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "center", mt: 1, mb: 1 }}>
            <a href="/clases-particulares-inteligencia-artificial/">{t("academy.guideIa")}</a>
            <a href="/clases-chatgpt/">{t("academy.guideChatgpt")}</a>
            <a href="/curso-n8n/">{t("academy.guideN8n")}</a>
            <a href="/agentes-de-ia/">{t("academy.guideAgents")}</a>
            <a href="/ia-para-el-trabajo/">{t("academy.guideJob")}</a>
          </Box>
        </Box>
        <AcademyBooking topic={topic} />
        <ContactSection />
        <Footer />
      </ContentWrapper>
    </>
  );
};

export default AcademyPeople;
